import { createFileRoute } from '@tanstack/react-router';

import { requirePermission } from '@/app/guards';
import {
  giftCardListParams,
  giftCardListQueryOptions,
  giftCardListSearchSchema,
  GiftCardsPage,
} from '@/features/gift-cards';

export const Route = createFileRoute('/_authed/_active/s/$storeId/gift-cards/')({
  staticData: { tours: ['gift-cards.list'] },
  validateSearch: giftCardListSearchSchema,
  loaderDeps: ({ search }) => search,
  beforeLoad: ({ context }) => {
    requirePermission(context.me, 'gift_cards.read');
  },
  loader: async ({ context, params, deps, cause }) => {
    const prefetch = context.queryClient
      .query({
        ...giftCardListQueryOptions(params.storeId, giftCardListParams(deps)),
        staleTime: 'static',
      })
      .catch(() => undefined);
    // Filter, sort and page changes on the list itself must not wait for the fetch, or a second
    // pick in the filter builds on the stale URL; the page shows the previous rows meanwhile.
    if (cause !== 'stay') await prefetch;
  },
  component: GiftCardsPage,
});
